export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/206052ae2e9a0890080884cbd9995409.png";